"use strict";
/* eslint-disable @typescript-eslint/no-empty-object-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCatalogueMessage = exports.createRequestCatalogueMessage = exports.createStateMessage = exports.createUpdateConsumableMessage = void 0;
const effect_1 = require("effect");
const createUpdateConsumableMessage = (namespace, slotsDef) => effect_1.Schema.TaggedStruct('UpdateConsumables', {
    consumables: effect_1.Schema.Tuple(...effect_1.Tuple.map(slotsDef, consumableConstructors => effect_1.Schema.Union(effect_1.Schema.TaggedStruct('Keep', {}).annotations({
        title: 'Keep',
        description: 'Keep the slot configuration exacly as it is.',
    }), effect_1.Schema.TaggedStruct('Remove', {}).annotations({
        title: 'Remove',
        description: 'Remove the consumable from the slot, if any.',
    }), effect_1.Schema.TaggedStruct('Recall', {}).annotations({
        title: 'Recall',
        description: 'Mark the conumable as recalled.',
    }), ...effect_1.Tuple.map(consumableConstructors, ConsumableConstructor => effect_1.Schema.TaggedStruct('Replace', {
        subset: ConsumableConstructor,
        initialState: ConsumableConstructor.State,
    }).annotations({
        title: `Replace: ${ConsumableConstructor.label}`,
        description: `Replace the installed consumable (if any) with a ${ConsumableConstructor.label}`,
    }))))),
}).annotations({
    identifier: `${namespace}.UpdateConsumables`,
    title: 'Update Consumables',
    description: 'A C2D message to update the consumables of a device',
});
exports.createUpdateConsumableMessage = createUpdateConsumableMessage;
const createStateMessage = (namespace, slotsDef) => effect_1.Schema.TaggedStruct('State', {
    state: effect_1.Schema.Tuple(...effect_1.Tuple.map(slotsDef, consumableConstructors => effect_1.Schema.Union(effect_1.Schema.Null.annotations({
        title: 'No Consumable',
        description: 'Passing `null` means that there is nothing installed in the slot.',
    }), ...effect_1.Tuple.map(consumableConstructors, ConsumableConstructor => effect_1.Schema.Struct({
        subset: effect_1.Schema.fromKey(effect_1.Schema.propertySignature(ConsumableConstructor.CatalogueItemFromId), 'subsetId').annotations({
            title: 'Subset Identifier',
            description: 'The value of the `id` property of the corresponding ' +
                'consumable definition (also known as a "subset").',
        }),
        stateId: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
            title: 'State Identifier',
            description: 'An ID that corresponds uniquely to the physical ' +
                'consumable instance that sits in the unit. This should ' +
                'only change when the consumable is replaced by another.' +
                '\n\n' +
                'If you cannot obtain a unique ID for the consumable, ' +
                'you can use the installation date as a fallback.',
        }),
        state: effect_1.Schema.propertySignature(ConsumableConstructor.State).annotations({
            title: 'State',
            description: 'An object describing the stateful properties of ' +
                'the consumable that is installed in this slot.',
        }),
    }).annotations({
        title: `Installed Consumable: ${ConsumableConstructor.label} ` +
            `(${ConsumableConstructor.category})`,
        description: 'An object describing which consumable is installed in this slot, ' +
            'and its current state.',
    }))))),
}).annotations({
    identifier: `${namespace}.State`,
    title: 'State Update',
    description: 'A D2C message to set the state of a consumable, and/or confirm the installed subset',
});
exports.createStateMessage = createStateMessage;
const createRequestCatalogueMessage = (namespace) => effect_1.Schema.TaggedStruct('RequestCatalogue', {}).annotations({
    identifier: `${namespace}.RequestCatalogue`,
    title: 'Request Catalogue',
    description: 'A D2C message to request the catalogue of consumables for a given device',
});
exports.createRequestCatalogueMessage = createRequestCatalogueMessage;
const createCatalogueMessage = (namespace, catalogue) => effect_1.Schema.TaggedStruct('Catalogue', { catalogue }).annotations({
    identifier: `${namespace}.Catalogue`,
    title: 'Catalogue',
    description: 'A C2D message to provide a device with the current catalogue of consumables',
});
exports.createCatalogueMessage = createCatalogueMessage;
//# sourceMappingURL=consumable.js.map